/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');

const ajax = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const tip = require('components/base/pop/tip');

require('./server-list.scss');
const template = require('./server-list.tpl');

const serverList = {
	name: "server-list",

	template,

	data() {
    return {
    	defaultImg: require('../../../../assets/default_icons.png'),
    	serverListTitle: "官方服务",
    	fetchRightNow: false,
    	official: false,
    	thItems: ["序号", "服务名称", "服务Logo", "链接类型", "平台", "用户", "New标识", "排序", "可见性", "操作"],
      url: "",
      thLength: 10,
      optionsWord: "",
      params: {
      	curId: "",
      	visible: "" 
      }
    }
	},
	route: {
    data(transition) {
			// debugger
      this.official = transition.to.official;
      this.serverListTitle = this.official ? "官方服务" : "第三方服务";
      this.url = apiPath.server.serverList + "?serviceType=" + (this.official ? 1 : 2) + "&_size=10"
			this.$refs.tableData.setUrl(this.url).fetch()
      transition.next();
    },
    waitForData: true
  },
	methods: {
		hideOrShow(curId, visible){	
			this.$set('params.serviceId', curId)
			if(visible == 1){
				this.$set('params.visible', 2)
			}else{
				this.$set('params.visible', 1)
			}
			this.optionsWord = visible == 1 ? '是否隐藏？' : '是否恢复显示？'
			this.$refs.hideOrShow.show()
		},
		hideOrShowCb(){
			ajax(apiPath.server.hideOrShow,{
				data: this.params,
				type: 'POST'
			}).then((res)=>{
				this.$refs.hideOrShow.hide()
				tip('设置成功！')
				setTimeout(()=>{
					this.$refs.tableData.fetch()
				},500)
			})
		}
	},
	filters: {
		platform(val){
			let arr = ['全部可见', 'ios可见', '安卓可见']
			if(val != null){
				return arr[val]
			}
		}
	}
}

module.exports = serverList;




// WEBPACK FOOTER //
// ./src/appBackend/components/page/server/server-list/server-list.js